import InterviewerTracks from '@huntica/huntica-interview-module/src/helpers/InterviewerTracks';
import { videoResolution } from '@huntica/huntica-interview-module/src/enums';

export default function useInterviewerMedia() {
  async function getVideoSrc(interviewer) {
    const tracks = new InterviewerTracks(interviewer.videoUrl);
    await tracks.load();
    let files = tracks.getFilesTrack(videoResolution.HD, 1.777777778);
    if (!files) {
      files = tracks.getFilesTrack(videoResolution.FULL_HD, 1.777777778);
    }
    return tracks.buildUrl(`${files.path}/hello.mp4`);
  }

  return {
    getVideoSrc,
  };
}
